export enum KnowledgeBaseTypeEnum {
    PDF = "pdf",
    WEBSITE = "website",
    COMBINED = "combined",
    SHAREPOINT = "SHAREPOINT",
}

export enum KnowledgeBaseFileStatusEnum {
    PENDING = "pending",
    PROCESSING = "processing",
    COMPLETED = "completed",
    FAILED = "failed"
}